import React from 'react';

import ClientDetailsCard from './ClientDetailsCard';
import KeyGoalsCard from './KeyGoalsCard';
import PrioritiesCard from './PrioritiesCard';
import IndustryTrendsCard from './IndustryTrendsCard';
import { CustomerResponse } from '../../types';

interface CustomerOverviewProps {
  customerDetails?: Partial<CustomerResponse>;
  onNavigateToGoals?: () => void;
  showSummaryCards?: boolean;
}

const CustomerOverview: React.FC<CustomerOverviewProps> = ({
  customerDetails,
  onNavigateToGoals,
  showSummaryCards = true,
}) => {
  const { customer_details, goals } = customerDetails ?? {};
  const customerName = customer_details?.name?.trim() || 'Customer Profile';

  return (
    <div className="p-6 space-y-6">
      <h1 className={`font-bold text-[#0F2A4F] ${showSummaryCards ? 'text-2xl' : 'text-center text-3xl md:text-4xl'}`}>
        {customerName}
      </h1>
      <div className={`grid grid-cols-1 gap-6 ${showSummaryCards ? 'lg:grid-cols-2' : ''}`}>
        <ClientDetailsCard
          details={customer_details}
          hideTitle={!showSummaryCards}
          hideCompanyName={!showSummaryCards}
        />
        {showSummaryCards && (
          <div className="flex flex-col space-y-4">
            <KeyGoalsCard keyGoals={goals?.key_goals || []} onSeeAll={onNavigateToGoals} />
            <PrioritiesCard priorities={goals?.priority_goals || []} onSeeAll={onNavigateToGoals} />
            <IndustryTrendsCard trends={goals?.trend_goals || []} onSeeAll={onNavigateToGoals} />
          </div>
        )}
      </div>
    </div>
  );
};

export default CustomerOverview;
